import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 网报吃瓜",
    description: "你访问的页面不存在或已被移动，可以返回首页或前往事件追踪列表继续查看官方通报时间线。",
    path: location.pathname,
    jsonLd: undefined,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="flex max-w-lg flex-col items-center text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-compass-3-line text-3xl"></i>
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950">页面走丢了</h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的地址不存在，可能链接输入有误，或页面已经调整。可以回到首页，或直接去事件追踪里找你要的那件事。
          </p>
          <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-home-4-line"></i>
              </span>
              返回首页
            </Link>
            <Link
              to="/events"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-list-check-3"></i>
              </span>
              事件追踪
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}